/* eslint-disable max-len */
import React from 'react';

const Text = () => (
  <section className="block block-text">
    <p>
      L’aproximació a la realitat urbana ja no és fixa i estàtica sinó més aviat flexible i dinàmica. L’ambigüitat, l’excepcionalitat, el desordre, les turbulències i les dinàmiques no lineals, creixen. Els diferents sistemes que conformen les ciutats estan entrellaçats i els seus problemes i les seves necessitats exigeixen un tractament en què aquests sistemes cooperin, simultàniament, en cadenes de fluxos i xarxes.
    </p>
    <p>
      La necessitat que motiva aquest projecte és la de donar un impuls a aquell comerç del barri de Sarrià que, quotidianament s’anomena ‘de barri’ o ‘de proximitat’, i fer-ho a través del pensament creatiu.
    </p>
    <p>
      El punt de partida escollit és establir una relació entre aquesta idea de ‘proximitat’ i allò que conforme l’espai públic, el seu ús: els carrers, les places, el veïnat, les activitats que s’hi fan, la vegetació, el mobiliari, la llum, els colors, etc. L’estudi d’aquesta relació desemboca amb la premissa que, la qualitat de l’espai públic té un impacte directe sobre la qualitat del comerç, i al revés. Així doncs, comerç de proximitat i espai públic, es necessiten per assolir una excel·lència que definim en termes de benestar i sostenibilitat social i medio-ambiental.
    </p>
    <p>
      <b>SARRIÀ:ECOSISTEMA</b> és l’eina digital editable que hem creat per permetre l’exploració d’aquesta relació entre comerç i espai públic del barri de Sarrià. Aquesta exploració ha de permetre, a qui ho desitgi, detectar oportunitats per activar aquests espais compartits i així impulsar el comerç del barri.
    </p>
  </section>
);

export default Text;
